// source: witbooking/backoffice/loyalty/brand/v1/loyalty_brand_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var witbooking_backoffice_loyalty_tier_v1_loyalty_tier_api_pb = require('../../../../../witbooking/backoffice/loyalty/tier/v1/loyalty_tier_api_pb.js');
goog.object.extend(proto, witbooking_backoffice_loyalty_tier_v1_loyalty_tier_api_pb);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.BookAndJoinType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddressType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.RegistrationTextType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse.displayName = 'proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brand: (f = msg.getBrand()) && proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.toObject(includeInstance, f),
    defaultCurrency: jspb.Message.getFieldWithDefault(msg, 2, ""),
    defaultLocale: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest;
  return proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.deserializeBinaryFromReader);
      msg.setBrand(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultCurrency(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultLocale(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrand();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.serializeBinaryToWriter
    );
  }
  f = message.getDefaultCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDefaultLocale();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional LoyaltyBrand brand = 1;
 * @return {?proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand}
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.prototype.getBrand = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand, 1));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest} returns this
*/
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.prototype.setBrand = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.prototype.clearBrand = function() {
  return this.setBrand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.prototype.hasBrand = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string default_currency = 2;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.prototype.getDefaultCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.prototype.setDefaultCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string default_locale = 3;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.prototype.getDefaultLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest.prototype.setDefaultLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse;
  return proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brand: (f = msg.getBrand()) && proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.toObject(includeInstance, f),
    defaultCurrency: jspb.Message.getFieldWithDefault(msg, 2, ""),
    defaultLocale: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest;
  return proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.deserializeBinaryFromReader);
      msg.setBrand(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultCurrency(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultLocale(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrand();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.serializeBinaryToWriter
    );
  }
  f = message.getDefaultCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDefaultLocale();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional LoyaltyBrand brand = 1;
 * @return {?proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand}
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.prototype.getBrand = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand, 1));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest} returns this
*/
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.prototype.setBrand = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.prototype.clearBrand = function() {
  return this.setBrand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.prototype.hasBrand = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string default_currency = 2;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.prototype.getDefaultCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.prototype.setDefaultCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string default_locale = 3;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.prototype.getDefaultLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest.prototype.setDefaultLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse;
  return proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest;
  return proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse;
  return proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest;
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    brand: (f = msg.getBrand()) && proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse;
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.deserializeBinaryFromReader);
      msg.setBrand(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrand();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.serializeBinaryToWriter
    );
  }
};


/**
 * optional LoyaltyBrand brand = 1;
 * @return {?proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.prototype.getBrand = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand, 1));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse} returns this
*/
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.prototype.setBrand = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.prototype.clearBrand = function() {
  return this.setBrand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.prototype.hasBrand = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandTicker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest;
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string brand_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest.prototype.getBrandTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest.prototype.setBrandTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    brand: (f = msg.getBrand()) && proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse;
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.deserializeBinaryFromReader);
      msg.setBrand(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrand();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.serializeBinaryToWriter
    );
  }
};


/**
 * optional LoyaltyBrand brand = 1;
 * @return {?proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.prototype.getBrand = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand, 1));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse} returns this
*/
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.prototype.setBrand = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.prototype.clearBrand = function() {
  return this.setBrand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.prototype.hasBrand = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest;
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandsList: jspb.Message.toObjectList(msg.getBrandsList(),
    proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse;
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.deserializeBinaryFromReader);
      msg.addBrands(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LoyaltyBrand brands = 1;
 * @return {!Array<!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand>}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.prototype.getBrandsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand>} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse} returns this
*/
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.prototype.setBrandsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.prototype.addBrands = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.prototype.clearBrandsList = function() {
  return this.setBrandsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest;
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandsList: jspb.Message.toObjectList(msg.getBrandsList(),
    proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse;
  return proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.deserializeBinaryFromReader);
      msg.addBrands(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LoyaltyBrand brands = 1;
 * @return {!Array<!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand>}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.prototype.getBrandsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand>} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse} returns this
*/
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.prototype.setBrandsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand}
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.prototype.addBrands = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.prototype.clearBrandsList = function() {
  return this.setBrandsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.repeatedFields_ = [3,5,6,7,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.toObject, includeInstance),
    transactionExpirationLimit: jspb.Message.getFieldWithDefault(msg, 4, 0),
    relatedDomainsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    usedByList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    managedByList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    externalSystemId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    mainDomain: jspb.Message.getFieldWithDefault(msg, 9, ""),
    authorizationServiceDomain: jspb.Message.getFieldWithDefault(msg, 11, ""),
    emailAddressesList: jspb.Message.toObjectList(msg.getEmailAddressesList(),
    proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.toObject, includeInstance),
    configuration: (f = msg.getConfiguration()) && proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.toObject(includeInstance, f),
    privacypolicyurl: jspb.Message.getFieldWithDefault(msg, 14, ""),
    communicationpolicyurl: jspb.Message.getFieldWithDefault(msg, 15, ""),
    bookAndJoinType: jspb.Message.getFieldWithDefault(msg, 16, 0),
    registrationTextType: jspb.Message.getFieldWithDefault(msg, 17, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand;
  return proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTransactionExpirationLimit(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addRelatedDomains(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addUsedBy(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addManagedBy(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalSystemId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMainDomain(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorizationServiceDomain(value);
      break;
    case 12:
      var value = new proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.deserializeBinaryFromReader);
      msg.addEmailAddresses(value);
      break;
    case 13:
      var value = new proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.deserializeBinaryFromReader);
      msg.setConfiguration(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrivacypolicyurl(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommunicationpolicyurl(value);
      break;
    case 16:
      var value = /** @type {!proto.witbooking.backoffice.loyalty.brand.v1.BookAndJoinType} */ (reader.readEnum());
      msg.setBookAndJoinType(value);
      break;
    case 17:
      var value = /** @type {!proto.witbooking.backoffice.loyalty.brand.v1.RegistrationTextType} */ (reader.readEnum());
      msg.setRegistrationTextType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.serializeBinaryToWriter
    );
  }
  f = message.getTransactionExpirationLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getRelatedDomainsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getUsedByList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getManagedByList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getExternalSystemId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMainDomain();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAuthorizationServiceDomain();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getEmailAddressesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.serializeBinaryToWriter
    );
  }
  f = message.getConfiguration();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getPrivacypolicyurl();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getCommunicationpolicyurl();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getBookAndJoinType();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getRegistrationTextType();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated LoyaltyBrandTranslation translations = 3;
 * @return {!Array<!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation>}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation, 3));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation>} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
*/
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * optional int32 transaction_expiration_limit = 4;
 * @return {number}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getTransactionExpirationLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setTransactionExpirationLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated string related_domains = 5;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getRelatedDomainsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setRelatedDomainsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.addRelatedDomains = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.clearRelatedDomainsList = function() {
  return this.setRelatedDomainsList([]);
};


/**
 * repeated string used_by = 6;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getUsedByList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setUsedByList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.addUsedBy = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.clearUsedByList = function() {
  return this.setUsedByList([]);
};


/**
 * repeated string managed_by = 7;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getManagedByList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setManagedByList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.addManagedBy = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.clearManagedByList = function() {
  return this.setManagedByList([]);
};


/**
 * optional string external_system_id = 8;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getExternalSystemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setExternalSystemId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string main_domain = 9;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getMainDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setMainDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string authorization_service_domain = 11;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getAuthorizationServiceDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setAuthorizationServiceDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * repeated LoyaltyBrandEmailAddress email_addresses = 12;
 * @return {!Array<!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress>}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getEmailAddressesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress, 12));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress>} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
*/
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setEmailAddressesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.addEmailAddresses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.clearEmailAddressesList = function() {
  return this.setEmailAddressesList([]);
};


/**
 * optional LoyaltyBrandConfiguration configuration = 13;
 * @return {?proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getConfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration, 13));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
*/
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setConfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.clearConfiguration = function() {
  return this.setConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.hasConfiguration = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string privacyPolicyUrl = 14;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getPrivacypolicyurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setPrivacypolicyurl = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string communicationPolicyUrl = 15;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getCommunicationpolicyurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setCommunicationpolicyurl = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional BookAndJoinType book_and_join_type = 16;
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.BookAndJoinType}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getBookAndJoinType = function() {
  return /** @type {!proto.witbooking.backoffice.loyalty.brand.v1.BookAndJoinType} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.BookAndJoinType} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setBookAndJoinType = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional RegistrationTextType registration_text_type = 17;
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.RegistrationTextType}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.getRegistrationTextType = function() {
  return /** @type {!proto.witbooking.backoffice.loyalty.brand.v1.RegistrationTextType} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.RegistrationTextType} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrand.prototype.setRegistrationTextType = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation;
  return proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandTranslation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress;
  return proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddressType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional LoyaltyBrandEmailAddressType type = 1;
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddressType}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.prototype.getType = function() {
  return /** @type {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddressType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddressType} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddress.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    enableemailchange: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    sendwelcomeemail: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    useexternaltier: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration;
  return proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableemailchange(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendwelcomeemail(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseexternaltier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnableemailchange();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getSendwelcomeemail();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getUseexternaltier();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional bool enableEmailChange = 1;
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.prototype.getEnableemailchange = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.prototype.setEnableemailchange = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool sendWelcomeEmail = 2;
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.prototype.getSendwelcomeemail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.prototype.setSendwelcomeemail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool useExternalTier = 3;
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.prototype.getUseexternaltier = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandConfiguration.prototype.setUseexternaltier = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    bookAndJoinType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest;
  return proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandId(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.backoffice.loyalty.brand.v1.BookAndJoinType} */ (reader.readEnum());
      msg.setBookAndJoinType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBookAndJoinType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string brand_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest.prototype.getBrandId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest.prototype.setBrandId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional BookAndJoinType book_and_join_type = 2;
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.BookAndJoinType}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest.prototype.getBookAndJoinType = function() {
  return /** @type {!proto.witbooking.backoffice.loyalty.brand.v1.BookAndJoinType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.BookAndJoinType} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest.prototype.setBookAndJoinType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse;
  return proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    registrationTextType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest;
  return proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandId(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.backoffice.loyalty.brand.v1.RegistrationTextType} */ (reader.readEnum());
      msg.setRegistrationTextType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRegistrationTextType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string brand_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest.prototype.getBrandId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest.prototype.setBrandId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional RegistrationTextType registration_text_type = 2;
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.RegistrationTextType}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest.prototype.getRegistrationTextType = function() {
  return /** @type {!proto.witbooking.backoffice.loyalty.brand.v1.RegistrationTextType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.RegistrationTextType} value
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest} returns this
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest.prototype.setRegistrationTextType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse;
  return proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandEmailAddressType = {
  SENDER: 0,
  RECEIVER: 1
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.loyalty.brand.v1.BookAndJoinType = {
  INVALID_BOOK_AND_JOIN_TYPE: 0,
  DISABLED: 1,
  OPT_IN: 2,
  OPT_OUT: 3
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.loyalty.brand.v1.RegistrationTextType = {
  INVALID_REGISTRATION_TEXT_TYPE: 0,
  WITH_SAVINGS: 1,
  WITHOUT_SAVINGS: 2
};

goog.object.extend(exports, proto.witbooking.backoffice.loyalty.brand.v1);
